import { useTranslator } from '@bluebeam/react-i18n';
import { useSubscription } from 'observable-hooks';
import * as toast from 'utils/toast';
import useToastEvents, { ToastEvent } from '../../hooks/useToastEvents';

const ToastSubscriptions: React.FC = () => {
  const toastEvents = useToastEvents();
  const { translate } = useTranslator(['toastText']);
  useSubscription(toastEvents, (toastEvent: ToastEvent) => {
    const { type, body, title, translationVariables } = toastEvent;

    switch (type) {
      case 'info':
        toast.info(translate(body), translate(title, translationVariables));
        break;
      case 'success':
        toast.success(translate(body), translate(title, translationVariables));
        break;
      case 'error':
        toast.error(translate(body), translate(title, translationVariables));
        break;
      default:
        break;
    }
  });

  return null;
};

export default ToastSubscriptions;
